// Shared query-string helper for the API client.
// Extracted from shops.api.ts so every module builds query strings the same
// way: skip undefined values, prepend "?" only when at least one key remains.

export function qs(params: Record<string, string | undefined>) {
  const u = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v) u.set(k, v);
  const s = u.toString();
  return s ? `?${s}` : "";
}
